/**
 * Where to send someone after they sign up or sign in. Set it before opening
 * the auth modal (or before a Google redirect); the modal and /auth/callback
 * take it once. Only same-site paths are accepted, so it can never be used to
 * send a visitor to another website.
 */
const KEY = "migrada_return_to";

const isSafePath = (p: string) => p.startsWith("/") && !p.startsWith("//") && !p.startsWith("/\\");

export function setReturnTo(path: string): void {
  if (!isSafePath(path)) return;
  try {
    window.localStorage.setItem(KEY, path);
  } catch {}
}

/** Reads and clears the stored path. Null when there is none (the caller decides the default). */
export function takeReturnTo(): string | null {
  try {
    const p = window.localStorage.getItem(KEY);
    window.localStorage.removeItem(KEY);
    return p && isSafePath(p) ? p : null;
  } catch {
    return null;
  }
}
